import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { SharedFeaturesModule } from '@shared-features/shared-features.module';
import { NotificationsComponent } from './components/notifications/notifications.component';

@NgModule({
  declarations: [NotificationsComponent],
  imports: [
    CommonModule,
    SharedModule,
    SharedFeaturesModule
  ],
  exports: [
    NotificationsComponent
  ]
})
export class NotificationsModule { }
